/**
 * Retrieves the translation of text.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/packages/packages-i18n/
 */
import { __ } from '@wordpress/i18n';

/**
 * React hook that is used to mark the block wrapper element.
 * It provides all the necessary props like the class name.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/packages/packages-block-editor/#useblockprops
 */

import { InspectorControls, useBlockProps } from '@wordpress/block-editor';
import {
	PanelBody,
	RangeControl,
	__experimentalNumberControl as NumberControl
  } from "@wordpress/components";
/**
 * Lets webpack process CSS, SASS or SCSS files referenced in JavaScript files.
 * Those files can contain any CSS code that gets applied to the editor.
 *
 * @see https://www.npmjs.com/package/@wordpress/scripts#using-css
 */
import './editor.scss';

/**
 * The edit function describes the structure of your block in the context of the
 * editor. This represents what the editor will render when the block is used.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-edit-save/#edit
 *
 * @return {WPElement} Element to render.
 */

import { Fragment } from '@wordpress/element';
import { BlockControls, AlignmentControl } from '@wordpress/block-editor';
import ServerSideRender from '@wordpress/server-side-render';

export default function Edit( props ) {
	const { setAttributes, attributes } = props;
	const { imageWidth, imageHeight } = attributes;
	
	return (
		<div { ...useBlockProps() }>
			<Fragment>
				<InspectorControls>
					<PanelBody>
						<RangeControl
							label={__("Image Width")}
							value={imageWidth}
							onChange={(value) => setAttributes({ imageWidth: value }) }
							min={1}
							max={1000}
						/>
						<RangeControl
							label={__("Image Height")}
							value={imageHeight}
							onChange={(value) => setAttributes({ imageHeight: value }) }
							min={1}
							max={1000}
						/>
					</PanelBody>
					
				</InspectorControls>
			</Fragment>
			
			<ServerSideRender
				block="wp-travel-blocks/guide-image"
				attributes={ props.attributes }
			/>
		</div>
	);
}
